export default __webpack_public_path__ + "static/media/uz.8e43b509.png";